import { faPaperclip, faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import ClientTreatmentAssignment from '../clients/_ClientTreatmentAssignment';
import { Popover } from 'antd';
import "./_tasks.css";
import ClientTreatmentEmail from '../clients/_ClientTreatmentEmail';
import EditReferenceTreatment from './_EditReferenceTreatment';
import { setCreateTreatmentFrom, setTaskStatusNotification } from '../app-context/tasksSlice';
import { useDispatch } from 'react-redux';
import { setLeadIdForTreatment } from '../app-context/leadsSlice';
import EditHandlerTreatment from './_EditHandlerTreatment';
import { set } from 'lodash';
import { el } from 'date-fns/locale';
import EditCommentCalling from './_EditCommentCalling';
import { setHandlerTreatmentPopUp } from '../app-context/signsSlice';

type Props = {
    data: any[] | null;
    sortBy?: any;
    className?: string;
    config?: any;
    actions?: any;
    fromLeads?: boolean;
    fromClient?: boolean;
    fromSue?: boolean;
    fromClientCard?: boolean;
    fromSign?: boolean;
};

const addCollumnsItems = {
    eventDate: {
        hidden: true,
        label: 'תאריך אירוע',
    },
    agent: {
        hidden: true,
        label: 'סוכן',
    },
    company: {
        hidden: true,
        label: 'חברה',
    },
    modifiedBy: {
        hidden: true,
        label: 'שונה ע"י',
    },
    changeDate: {
        hidden: true,
        label: 'תאריך שינוי',
    },
    groups: {
        hidden: true,
        label: 'קבוצות',
    },
    employer: {
        hidden: true,
        label: 'מעסיק',
    },
    referrence: {
        hidden: true,
        label: 'שייך ל',
    }
}


const SelectCollumnsPopOver = (props: any) => {

    const [optionsList, setOptionsList] = useState<any[]>([]);

    const buildOptionslist = () => {
        const collumnsNames = Object.keys(props.options);
        const rows: any[] = [];
        collumnsNames.forEach((collumn: string, key: number) => {
            rows.push({
                label: props.options[collumn].label,
                value: collumn,
                checked: !props.options[collumn].hidden
            });
        });
        setOptionsList(rows);

    }

    const onCheck = (optionValue: string) => {
        console.log('SelectCollumnsPopOver onCheck', optionValue);
        if (props.onCheck) {
            const opts = props.options;
            opts[optionValue].hidden = !opts[optionValue].hidden
            console.log('SelectCollumnsPopOver onCheck props.options', props.options, opts);
            props.onCheck(opts)
        }
    }

    const onClose = () => {
        if (props.onHide) {
            props.onHide()
        }
    }

    useEffect(() => {
        buildOptionslist();
    }, [props.options]);

    useEffect(() => {
        buildOptionslist();
    }, []);

    return (
        <div>
            {optionsList.map((option: any, index: number) => {
                return (
                    <div key={index} className='flex-start flex-reverse'>
                        <input type='checkbox' onChange={() => onCheck(option.value)} />
                        <div>
                            {option.label}
                        </div>
                    </div>
                )
            })}
            <a onClick={onClose}>Close</a>

        </div>
    )
}

const TasksTable = (props: Props) => {

    const dispatch = useDispatch();

    const [taskItemsList, setTaskItemsList] = useState<any[]>([]);
    const [showDropDown, setShowDropDown] = useState(false);

    const [additionalColumns, setAdditionalColumns] = useState<any>({
        eventDate: {
            hidden: true,
            label: 'תאריך אירוע',
        },
        agent: {
            hidden: true,
            label: 'סוכן',
        },
        company: {
            hidden: true,
            label: 'חברה',
        },
        modifiedBy: {
            hidden: true,
            label: 'שונה ע"י',
        },
        changeDate: {
            hidden: true,
            label: 'תאריך שינוי',
        },
        groups: {
            hidden: true,
            label: 'קבוצות',
        },
        employer: {
            hidden: true,
            label: 'מעסיק',
        },
        referrence: {
            hidden: true,
            label: 'שייך ל',
        }
    });


    const [sortBy, setSortBy] = useState<any | null>(null);
    const [fromLeadTableType, setfromLeadTableType] = useState<boolean>(false);

    const [showEditReferencePopUp, setShowEditReferencePopUp] = useState(false);
    const [showEditHandlerTreatmentPopUp, setShowEditHandlerTreatmentPopUp] = useState(false);

    const [treatmentIdForEdit, setTreatmentIdForEdit] = useState<string>('');
    const [treatmentData, setTreatmentData] = useState<any>(null);

    const [showEditCommentForCallPopUp, setShowEditCommentForCallPopUp] = useState(false);





    const onSortChange = (property: string) => {
        if (props.actions.onSortChange) {
            props.actions.onSortChange(property)
        }
    }


    const handleOpenChange = (newOpen: boolean) => {
        setShowDropDown(newOpen);
    };

    const onMenuOptionChange = (options: any) => {
        setAdditionalColumns(options)
    }


    const editTask = (id: string) => {
        console.log('editTask');
        if (props.actions && props.actions.edit) {
            props.actions.edit(id)
        }
    }

    const referenceTask = (id: string) => {
        const treatment = taskItemsList.find((item: any) => item.id == id);
        console.log('referenceTask', treatment)
        if (treatment) {
            setTreatmentData(treatment);
            if (props.fromLeads && props.fromLeads == true) {
                if (treatment.customerId) {
                    setTreatmentIdForEdit(treatment.customerId);
                } else if (treatment.leadRelatedId) {
                    setTreatmentIdForEdit(treatment.leadRelatedId);
                    dispatch(setLeadIdForTreatment(treatment.leadRelatedId));
                } else if (treatment.offerRelated && treatment.offerRelated.leadId) {
                    setTreatmentIdForEdit(treatment.offerRelated.leadId);
                    dispatch(setLeadIdForTreatment(treatment.offerRelated.leadId));
                }
                dispatch(setCreateTreatmentFrom({ type: 'lead', id: treatmentIdForEdit }));


            } else {
                setTreatmentIdForEdit(treatment.customerId);
                if (treatment.leadRelatedId && treatment.leadRelatedId.length > 0) {
                    setTreatmentIdForEdit(treatment.leadRelatedId);
                }
            }
            // setTreatmentIdForEdit(treatment.customerId ? treatment.customerId : treatment.leadRelatedId);
            setShowEditReferencePopUp(true);
        }

        // if (props.actions && props.actions.reference) {
        //     props.actions.reference(id)
        // }
    }

    const changeHandler = (id: string) => {
        const treatment = taskItemsList.find((item: any) => item.id == id);
        if (treatment) {
            setTreatmentData(treatment);
            if (props.fromLeads && props.fromLeads == true) {
                if (treatment.leadRelatedId) {
                    dispatch(setLeadIdForTreatment(treatment.leadRelatedId));
                } else if (treatment.offerRelated && treatment.offerRelated.leadId) {
                    dispatch(setLeadIdForTreatment(treatment.offerRelated.leadId));
                }
            } else {

            }
            if(props.fromSign){
                dispatch(setHandlerTreatmentPopUp({treatmentData: treatment, show: true}));
            }else{
                setShowEditHandlerTreatmentPopUp(true);
            }
        }
    }

    const editEmail = (id: string) => {
        console.log('editEmail TaskTable');
        if (props.actions && props.actions.editEmail) {
            props.actions.editEmail(id)
        }
    }
    const sendEmail = (id: string) => {
        console.log('sendEmail');
        if (props.actions && props.actions.sendEmail) {
            props.actions.sendEmail(id)
        }
    }

    const editDoc = (id: string) => {
        console.log('editDoc');
        if (props.actions && props.actions.editDoc) {
            props.actions.editDoc(id)
        }
    }

    const sendWhatsApp = (id: string) => {
        console.log('sendWhatsApp');
        if (props.actions && props.actions.sendWhatsApp) {
            props.actions.sendWhatsApp(id)
        }
    }
    const setStatus = async (id: string, status: string) => {
        console.log('setStatus');
        if (props.actions && props.actions.setStatus) {
            await props.actions.setStatus(id, status);
            await props.actions.updateSeen(id);
            setTimeout(() => {
                dispatch(setTaskStatusNotification(true));
            }, 2000);

        }
    }
    const deleteAssigment = (id: string, status: string) => {
        console.log('deleteAssigment');
        if (props.actions && props.actions.delete) {
            props.actions.delete(id);
        }
    }

    const onShowDocument = (urls: any[]) => {
        if (props.actions && props.actions.onShowDocument) {
            console.log('onShowDocument-TaskTable-urls', urls)
            props.actions.onShowDocument(urls);
        }
    }

    const redirectToClient = (customer: any) => {
        if (props.actions && props.actions.redirectToClient) {
            props.actions.redirectToClient(customer);
        }
    }

    useEffect(() => {
        // remove twoelements from additionalColumns employer and groups
        const newAdditionalColumns = { ...additionalColumns };
        if (props.fromLeads && props.fromLeads == true) {
            delete newAdditionalColumns.employer;
            delete newAdditionalColumns.groups;
        }

        setAdditionalColumns(newAdditionalColumns);
        // if (props.fromLeads && props.fromLeads == true) {
        //     setAdditionalColumnsStorage('additionalColumnsLeads');
        // } else if(props.fromClient && props.fromClient == true){
        //     setAdditionalColumnsStorage('additionalColumnsClient');
        // } else {
        //     setAdditionalColumnsStorage('additionalColumnsTasks');
        // }
        // // setAdditionalColumns(newAdditionalColumns);
        // console.log('TasksTable useEffect', props.config);
    }, []);


    const setAdditionalColumnsStorage = (storageName: any) => {
        const additionalColumnsStorage = localStorage.getItem(storageName);
        if (additionalColumnsStorage) {
            const parsedAdditionalColumns = JSON.parse(additionalColumnsStorage);
            setAdditionalColumns(parsedAdditionalColumns);
        } else {
            const newAdditionalColumns = { ...additionalColumns };
            if (props.fromLeads && props.fromLeads == true) {
                delete newAdditionalColumns.employer;
                delete newAdditionalColumns.groups;
                delete newAdditionalColumns.identifier;
                delete newAdditionalColumns.phoneNumber;
            } else if (props.fromClient && props.fromClient == true) {
                delete newAdditionalColumns.identifier;
                delete newAdditionalColumns.phoneNumber;
            }

            setAdditionalColumns(newAdditionalColumns);
            localStorage.setItem(storageName, JSON.stringify(newAdditionalColumns));
        }
    }

    useEffect(() => {
        const data = props.data ? props.data : [];
        setTaskItemsList(data);
        console.log('data changed', props.data)
    }, [props.data]);
    useEffect(() => {
        setSortBy(props.sortBy);
        console.log('data sortBy changed', props.sortBy)
    }, [props.sortBy]);

    useEffect(() => {
        if (props.fromLeads && props.fromLeads == true) {
            setfromLeadTableType(props.fromLeads);

        }
    }, [props.fromLeads]);


    const onCloseEditReferenceTreatment = () => {
        setShowEditReferencePopUp(false);
        dispatch(setLeadIdForTreatment(''));
        if (props.actions && props.actions.getTreatments) {
            props.actions.getTreatments();
        }
    }

    const onCloseEditHandlerTreatment = () => {
        setShowEditHandlerTreatmentPopUp(false);
        dispatch(setLeadIdForTreatment(''));
        if (props.actions && props.actions.getTreatments) {
            props.actions.getTreatments();
        }

    }

    const editCalling = (id: string) => {
        const treatment = taskItemsList.find((item: any) => item.id == id);
        console.log('referenceTask', treatment)
        if (treatment) {
            setTreatmentData(treatment);
            if (treatment.leadRelatedId) {
                    dispatch(setLeadIdForTreatment(treatment.leadRelatedId));
                } else if (treatment.offerRelated && treatment.offerRelated.leadId) {
                    dispatch(setLeadIdForTreatment(treatment.offerRelated.leadId));
                }
            setShowEditCommentForCallPopUp(true);
        }
    }

    return (

        <>
            {
                showEditReferencePopUp ?
                    <EditReferenceTreatment
                        customerId={treatmentIdForEdit}
                        onClose={() => onCloseEditReferenceTreatment()}
                        onSave={() => setShowEditReferencePopUp(false)}
                        show={showEditReferencePopUp}
                        treatment={treatmentData}
                    />
                    : <></>
            }

            {
                showEditHandlerTreatmentPopUp ?
                    <EditHandlerTreatment
                        onClose={() => onCloseEditHandlerTreatment()}
                        show={showEditHandlerTreatmentPopUp}
                        treatment={treatmentData}
                    />
                    : <></>
            }

            {showEditCommentForCallPopUp ?
                <EditCommentCalling
                    onClose={() => setShowEditCommentForCallPopUp(false)}
                    treatment={treatmentData}
                />
                : <></>
            }
            <div className={`content-table tasks-content-table ${props.className ? props.className : ''}`} style={{ height: 'max-content'}}>
                <div className='content-header content-table-header client-tasks-list-header'>
                    <div className="content-table-header flex-centered" style={{ width: props.fromSign ? '98%' : '' }}>
                        <div className='row-cell icon-cell'>
                            &nbsp;
                        </div>
                        <div className={`row-cell status pointer`} onClick={() => onSortChange('assignmentStatusId')}>
                            סטטוס
                            <div className={`icon sort ${
                                props.sortBy && props.sortBy.property == 'assignmentStatusId' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>
                        <div
                            className={`row-cell client-name pointer 
                            ${fromLeadTableType ||(props.fromClientCard || props.fromSue ) ? 'hide' : ''}`} onClick={() => onSortChange('Customer.FirstName')}>
                            <div>
                                שם לקוח</div>
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'Customer.FirstName' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>

                        <div className={`row-cell client-id pointer`} onClick={() => onSortChange('Customer.Identifier')}
                            style={{ display: fromLeadTableType === true || (props.fromClientCard || props.fromSue ) ? 'none' : '' }}>
                            ת.ז. לקוח
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'Customer.Identifier' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>

                        <div className={`row-cell client-id pointer`} onClick={() => onSortChange('Customer.customerContactDetails[0].phoneNumber')}
                            style={{ display: fromLeadTableType === true || (props.fromClientCard || props.fromSue ) ? 'none' : '' }}>
                            טלפון
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'Customer.customerContactDetails[0].phoneNumber' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>

                        <div className='row-cell created createdDate pointer' onClick={() => onSortChange('createdDate')}>
                            תאריך יצירה
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'createdDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>

                        <div className={`row-cell eventDate eventDate pointer ${additionalColumns.eventDate.hidden ? 'hide' : ''}`} onClick={() => onSortChange('eventDate')}>
                            תאריך אירוע

                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'eventDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>


                        <div className='row-cell alertDate pointer' onClick={() => onSortChange('alertDate')}
                            style={{ display: props.fromSign ? 'none' : '' }}>
                            תאריך תזכורת
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'alertDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>
                        <div className={`row-cell short endOfGoal pointer`} onClick={() => onSortChange('endDate')}>
                            יעד סיום
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'endDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>
                        <div className='row-cell topic pointer' onClick={() => onSortChange('topic')}>
                            נושא
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'topic' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>
                        <div className='row-cell handler' onClick={() => onSortChange('belongsTo')}>
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'belongsTo' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                            מטפל
                        </div>
                        <div className='row-cell treatment-note'>
                            הערות
                        </div>
                        <div className='row-cell creator pointer' onClick={() => onSortChange('UserId')}>
                            נוצר ע"י
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'UserId' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>
                        <div className='row-cell file icon-file-cell'>
                            <FontAwesomeIcon icon={faPaperclip} />
                        </div>
                        {/* שדות דינאמים */}
                        {/* <div className={`row-cell short portfolio ${additionalColumns.portfolio.hidden ? 'hide' : ''}`}>
                    שיוך לתיק 
                    </div> */}
                        <div className={`row-cell short agent ${additionalColumns.agent.hidden ? 'hide' : ''}`}>
                            סוכן
                        </div>
                        <div className={`row-cell short company ${additionalColumns.company.hidden ? 'hide' : ''}`} onClick={() => onSortChange('company')}>
                            חברה
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'company' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>
                        <div className={`row-cell short client-name modifiedBy ${additionalColumns.modifiedBy.hidden ? 'hide' : ''}`}>
                            שונה ע"י
                        </div>
                        <div className={`row-cell short changeDate ${additionalColumns.changeDate.hidden ? 'hide' : ''}`} onClick={() => onSortChange('updatedDate')}>
                            תאריך שינוי
                            <div className={`icon sort ${props.sortBy && props.sortBy.property == 'updatedDate' ? props.sortBy.SortDirection == 'ASC' ? 'asc' : 'desc' : 'hide'
                                }`}></div>
                        </div>
                        {!fromLeadTableType &&
                            <div className={`row-cell short groups ${additionalColumns.groups.hidden ? 'hide' : ''}`}>
                                קבוצות
                            </div>
                        }
                        {!fromLeadTableType &&
                            <div className={`row-cell short employer ${additionalColumns.employer.hidden ? 'hide' : ''}`}>
                                מעסיק
                            </div>
                        }
                        <div className={`row-cell short referrence ${additionalColumns.referrence.hidden ? 'hide' : ''}`}>
                            שייך ל
                        </div>
                        {/* <div className='row-cell'>
                        <FontAwesomeIcon icon={faWrench} />
                    </div> */}
                        <div className="row-cell actions">
                            {/* <Dropdown menu={{ items: addCollumnsItems }} trigger={['click']}>
                        <div className='icon add black pointer'></div>
                    </Dropdown> */}
                            <Popover
                                placement="bottom"
                                content={<SelectCollumnsPopOver options={additionalColumns} onCheck={(opts: any) => onMenuOptionChange(opts)} onHide={() => handleOpenChange(false)} />}
                                title="Title"
                                trigger="click"
                                open={showDropDown}
                                onOpenChange={handleOpenChange}
                            >
                                <div className='icon add black pointer'></div>
                            </Popover>
                        </div>
                    </div>
                </div>
                <div className={(props.fromLeads || props.fromClient || props.fromClientCard) ? '' : 'content-data-table content-body content-table-body content-tasks-table-body'}
                    style={(props.fromLeads  || props.fromClientCard ) ? { height: 'fit-content', maxHeight: '400px', overflowY: 'auto' } 
                    : props.fromClient ? { height: 'fit-content', maxHeight: '650px', overflowY: 'auto' } : undefined}
                    >
                    {props.data && props.data.length == 0 ? (<div className='no-data'>אין נתונים</div>) : (<></>)}
                    {taskItemsList ? (<>
                        {taskItemsList.map((taskItem: any, index: number) => {
                            if (taskItem && taskItem.treatmentType != 3) {
                                return (
                                    <ClientTreatmentAssignment treatmentDetails={taskItem}
                                        config={{
                                            additionalColumns: additionalColumns
                                        }}
                                        actions={{
                                            edit: editTask,
                                            reference: referenceTask,
                                            changeHandler: changeHandler,
                                            editDoc: editDoc,
                                            sendEmail: sendEmail,
                                            sendWhatsApp: sendWhatsApp,
                                            setStatus: setStatus,
                                            delete: deleteAssigment,
                                            onShowDocument: onShowDocument,
                                            redirectToClient: redirectToClient,
                                            editCalling: editCalling,
                                        }}
                                        key={index}
                                        fromLeadTableType={fromLeadTableType}
                                        fromClientTableType={props.fromClient ? props.fromClient : false}
                                        fromSue={props.fromSue ? props.fromSue : false}
                                        fromClientCard={props.fromClientCard ? props.fromClientCard : false}
                                        fromSign={props.fromSign ? props.fromSign : false}
                                    />
                                )
                            } else if (taskItem && taskItem.treatmentType == 3) {
                                return (
                                    <ClientTreatmentEmail treatmentDetails={taskItem}
                                        config={{
                                            additionalColumns: additionalColumns
                                        }}
                                        actions={{
                                            edit: editTask,
                                            reference: referenceTask,
                                            editEmail: editEmail,
                                            sendEmail: sendEmail,
                                            sendWhatsApp: sendWhatsApp,
                                            setStatus: setStatus,
                                            delete: deleteAssigment,
                                            onShowDocument: onShowDocument,
                                            redirectToClient: redirectToClient,
                                        }}
                                        key={index}
                                        fromLeadTableType={fromLeadTableType}
                                    />
                                )
                            }
                        })}
                    </>) : (<></>)}
                </div>
            </div>
        </>

    )
}
export default TasksTable;